export default __webpack_public_path__ + "static/media/view_detail_icon.935daeca.svg";